import React, { useState, useContext, useEffect, useRef } from "react";
import '../../../ui-styles/bottomSlider/BottomSlider.css';
import "../../doctor/doctorProfile/doctorProfile.css";
import InputField from "../../../lib/ui/inputs/Input";
import AddrDropDown from "../../../lib/ui/dropdown/addressDropDown";
import { LangCtx } from "../../../lib/context";
import statesList from "../../../config/states.json";
import citiesList from "../../../config/cities.json";
import countriesList from "../../../config/countries.json";
import PhoneInput from 'react-phone-number-input';
import 'react-phone-number-input/style.css';


//const districtList = [{ value: "Agra", label: "Agra" }, { value: "Aligarh", label: "Aligarh" }, { value: "Balarampur", label: "Balarampur" }, { value: "Banda", label: "Banda" }, { value: "Bareilly", lable: "Bareilly" }]
//const states = [{ value: 'UttarPradesh', label: "UttarPradesh" }, { value: 'Andhra Pradesh', label: "Andhra Pradesh" }, { value: "Arunachal Pradesh", label: "Arunachal Pradesh" }, { value: "", label: "" }]
//const divisions = [{ value: "Agra", label: "Agra" }, { value: "Firozabad", label: "Firozabad" }, { value: "Mathura", label: "Mathura" }, { value: "Mainpuri", label: "Mainpuri" },]

const EditClinicProfile = (props) =>
{
    const { l } = useContext(LangCtx);
    const divRef = useRef();
    const pinRef = useRef();
    const stateRef = useRef();
    const cityRef = useRef();
    const { error, errorMsg } = props;
    const [ states, setStates ] = useState([ {
        value: "",
        label: l.select_state
    }, ]);
    const [ cities, setCities ] = useState([ {
        value: "",
        label: l.select_city
    }, ]);

    useEffect(() =>
    {
        if (props?.data?.country)
        {
            handleStates(props?.data?.country);
        }
    }, []);

    useEffect(() =>
    {
        if (props?.data?.country)
        {
            handleStates(props?.data?.country);
        }
    }, [ props?.data?.country ]);

    useEffect(() =>
    {
        props?.data?.stateName ? handleCities(props?.data?.stateName) : setCities([{value: "", label: l.select_city}])
    }, [ props?.data?.stateName ]);

    useEffect(() =>
    {
        if (props.error)
        {
            divRef.current.scroll({
                top: 0,
                behavior: "smooth"
            });
        }
    }, [ props.errorMsg ]);

    // useEffect(() =>
    // {
    //     if (error.pincode)
    //     {
    //         pinRef.current.focus();
    //     }
    // }, [ error.pincode ]);
    useEffect(() =>
        {
            if (error.state)
            {
                stateRef.current.focus();
            }
            if (error.city)
            {
                cityRef.current.focus();
            }
            if (error.pincode)
            {
                pinRef.current.focus();
            }
        }, [ error.state, error.city, error.pincode ]);
    useEffect(() => {
        if (!props.editProfile) {
            props.resetError(); 
        }
    }, [props.editProfile]);

    const handleStates = (country) =>
    {
        let _statesList = statesList.filter((state) =>
        {
            return state.countryid === country;
        });
        _statesList.unshift({
            value: "",
            label: l.select_state
        });
        _statesList.sort((a, b) => a.value < b.value ? -1 : a.value > b.value ? 1 : 0);
        setStates([ ..._statesList ]);
    };

    const handleCities = (state) =>
    {
        let _citiesList = citiesList.filter((city) =>
        {
            return city.stateid === state;
        });
        if (_citiesList.length === 0) {
            _citiesList = [{
                value: "",
                label: l.no_cities_available 
            }];
        } else {
            _citiesList.unshift({
                value: "",
                label: l.select_city
            });
        }
        _citiesList.sort((a, b) => a.value < b.value ? -1 : a.value > b.value ? 1 : 0);
        setCities(_citiesList);
    };

    // console.log('err in clinic profile', props);

    return (
        <div className={props.editProfile ? "btmSlider slideUp" : "btmSlider"}>

            <div className="btmSliderPaper">
                <div className="btmSliderHdr">
                    <div className="btmHeaderRow">
                        <div className="hdrTxtGroup" onClick={props.handleEditProfle}>
                            <span className="hdrBtnTxt">{l.cancel}</span>
                        </div>
                        <div className="hdrTxtGroup" onClick={(e) => props.handleUpdateClinic(e)}>
                            <span className="hdrBtnTxt">{l.save}</span> </div>
                    </div>
                </div>
                <div className="btmSliderBdy" ref={divRef}>
                    {props.errorMsg &&
                        <div className="errorBox">
                            <small className="errorTxt">{props.errorMsg}</small>
                        </div>
                    }
                    <div className="inputListGroup">
                        <form>
                            <small className="inpLabel">{l.edit_clc_name}<span className="redTxt">*</span>:</small>
                            <InputField
                                placeholder={l.edit_clc_name}
                                type="text"
                                name="clinicName"
                                value={props.data.clinicName ? props.data.clinicName : ''}
                                error={error && error.clinicName}
                                errorMsg={error.clinicName}
                                maxLength="200"
                                onChange={(e) => props.handleChange(e)}
                            />
                            {/*  <small className="inpLabel">{l.edit_clc_id}<span className="redTxt">*</span>:</small>
                            <InputField
                                placeholder={l.edit_clc_id}
                                type="text"
                                name="clinicId"
                                value={props.data.clinicId ? props.data.clinicId : ''}
                                onChange={(e) => props.handleChange(e)}
                            />
                               <InputField
                                placeholder={l.edit_clc_username}
                                type="text"
                                name="contactName"
                                value={(e)=>props.handleChange(e)}
                            />*/}
                            <small className="inpLabel">{l.edit_clc_contact_name}<span className="redTxt">*</span>:</small>
                            <InputField
                                placeholder={l.edit_clc_contact_name}
                                type="text"
                                name="contactName"
                                value={props.data.contactName ? props.data.contactName : ''}
                                error={error && error.contactName}
                                errorMsg={error.contactName}
                                maxLength="30"
                                onChange={(e) => props.handleChange(e)}
                            />
                            <small className="inpLabel">{l.edit_phone_no}<span className="redTxt">*</span>:</small>

                            {/* <InputField
                                placeholder={l.edit_phone_no}
                                type="text"
                                name="phone"
                                value={props.data.phone ? props.data.phone.slice(-10) : ''}
                                onChange={(e) => props.handleChange(e)}
                        /> */}
                            <PhoneInput
                                className="customPkgInput"
                                international
                                countryCallingCodeEditable={false}
                                defaultCountry="IN"
                                //   value={props?.data.phone ? props?.data.phone : '' }
                                value={props?.data?.phone ? props?.data?.phone : ''}
                                maxLength="17"
                                error={error && error?.phone}
                                errorMsg={error?.phone}
                                onChange={(e) => props.handlePhoneChange(e)}
                            />
                            {(errorMsg && errorMsg.phone) && <span className="inputErrorMsg">{errorMsg.phone}</span>}

                            <small className="inpLabel">{l.email}<span className="redTxt">*</span>:</small>
                            {props?.data && props?.data?.email ?
                                <div className="profleHdngRow">{props?.data?.email}</div>
                                : <InputField
                                    placeholder={l.email}
                                    type="text"
                                    name="email"
                                    maxLength="50"
                                    value={props?.data?.email ? props.data.email : ''}
                                    error={error && error.email}
                                    errorMsg={error.email}
                                    onChange={(e) => props.handleChange(e)}
                                />
                            }

                            {/*<InputField
                                placeholder={l.email}
                                type="text"
                                name="email"
                                value={props.data.email}
                                disabled
                                // error={error && error.email}
                                // errorMsg={error.email}
                                onChange={(e) => props.handleChange(e)}
                            />*/}
                            <small className="inpLabel">{l.pat_address}:</small>
                            <InputField
                                placeholder={l.pat_address}
                                type="text"
                                name="address"
                                maxLength="500"
                                value={props.data.address ? props.data.address : ''}
                                onChange={(e) => props.handleChange(e)}
                            />
                            {/* <small className="inpLabel">{l.select_country}<span className="redTxt">*</span>: */}
                            <small className="inpLabel">{l.select_country}:</small>
                            {/* </small> */}
                            <AddrDropDown
                                placeholder={l.select_country}
                                items={countriesList}
                                value={props.data.country ? props.data.country : ''}
                                error={error && error.country}
                                errorMsg={error.country}
                                name="country"
                                onChange={(e) => props.handleChange(e)}
                            />
                            {/* <small className="inpLabel">{l.select_state}<span className="redTxt">*</span>:</small> */}
                            <small className="inpLabel">{l.select_state}:</small>
                            <AddrDropDown
                                // placeholder={l.select_state}
                                items={states}
                                value={props.data.stateName ? props.data.stateName : ''}
                                error={error && error.state}
                                errorMsg={error.state}
                                name="stateName"
                                onChange={(e) => props.handleChange(e)}
                            />
                            {/* <small className="inpLabel">{l.select_city}<span className="redTxt">*</span>:</small> */}
                            <small className="inpLabel">{l.select_city} :</small>
                            <AddrDropDown
                                // placeholder={l.select_city}
                                items={cities}
                                value={props.data.city ? props.data.city : ''}
                                error={error && error.city}
                                errorMsg={error.city}
                                name="city"
                                onChange={(e) => props.handleChange(e)}
                            />
                            {/* <small className="inpLabel">{l.edit_pin}<span className="redTxt">*</span>:</small> */}
                            <small className="inpLabel">{l.edit_pin}:</small>
                            <InputField
                                placeholder={l.edit_pin}
                                type="text"
                                name="pincode"
                                maxLength="15"
                                value={props.data.pincode ? props.data.pincode : ''}
                                error={error && error.pincode}
                                errorMsg={error.pincode}
                                ref={pinRef}
                                onChange={(e) => props.handleChange(e)
                                    // const numericValue = e.target.value.replace(/\D/g, '');
                                    // props.handleChange('pincode', numericValue)
                                }
                            />
                        </form>
                    </div>
                </div>
            </div>
        </div>
    );
};
export default EditClinicProfile;
